module.exports = __webpack_public_path__ + "img/apps-w.svg";